import { createAction } from 'redux-actions';

export const setCategory = createAction('SET_CATEGORY');
export const setStatistics = createAction('SET_STATISTICS');
